export const degreeSymbol = '\xB0';
